export function undoFunc(
  tableData,
  setTableData,
  undoTableData,
  redoTableData
) {
  if (undoTableData.length > 0) {
    redoTableData.push(tableData);
    setTableData(undoTableData[undoTableData.length - 1]);
    undoTableData.pop();
  }
}
